<template>
    <div v-if="careersJson" class="filter-sidebar" :class="{ open: filterDepartmentOpen }" @click.stop>
        <div class="filter-sidebar-inner">
            <div class="title-line">
                <span>Filter</span>
                <div @click="closeFilter" class="close-button"></div>
            </div>
            <div class="horizontal-line"></div>
            <div class="checkboxes">
                <div
                    v-for="category in filteredDepartments"
                    :key="category.slug"
                    :class="['checkbox-item', { active: isChecked(category) }]"
                    @click="handleFilterClick(category)"
                >
          <span class="box">
              <CheckBox class="cb"/>
          </span>
                    <span class="lbl">{{ category.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CheckBox from "@/components/svgs/CheckBox.vue";
export default {
    name: "FilterDepartmentSidebar",
    components: {
        CheckBox,
    },
    data() {
        return {
            globalJson: {}
        };
    },
    computed: {
        ...mapState({
            careersJson: state => state.careersJson,
            filterDepartmentOpen: state => state.filterDepartmentOpen,
            selectedDepartmentFilters: state => state.selectedDepartmentFilters
        }),
        filteredDepartments() {
            // Map over the careers JSON to extract the department value from the metadata
            const departments = this.careersJson
                .map(job => {
                    const deptMeta = job.metadata.find(meta => meta.name === "Career Page - Sub Department");
                    return deptMeta ? deptMeta.value : '';
                })
                .filter(Boolean); // Remove any empty values

            // Get unique department names using a Set
            const uniqueDepartments = [...new Set(departments)];

            // Map each unique department name to an object with label and slug
            const departmentList = uniqueDepartments.map(label => {
                const slug = label
                    .toLowerCase()                     // Convert to lowercase
                    .replace(/[^a-z0-9]+/g, '-')         // Replace non-alphanumeric characters with dashes
                    .replace(/^-+|-+$/g, '');            // Remove any leading/trailing dashes
                return { label, slug };
            });

            // Manually add "All Departments" as the first object
            return [{ label: "All Departments", slug: "all" }, ...departmentList];
        }
    },
    mounted() {
        // Assuming the global JSON config is available on window.config.json.global
        this.globalJson = window.config.json.global;
        // Listen for escape key globally
        document.addEventListener("keydown", this.handleEscape);
    },
    beforeUnmount() {
        document.removeEventListener("keydown", this.handleEscape);
    },
    watch: {
        $route() {
            // Automatically close the filter on route changes
            this.closeFilter();
        },
        careersJson() {

        },
        filterOpen(newVal) {
            if (newVal) {
                // Use nextTick to ensure the sidebar has fully opened before adding the listener
                this.$nextTick(() => {
                    document.addEventListener("click", this.handleClickOutside);
                });
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        }
    },
    methods: {
        closeFilter() {
            this.$store.commit("closeDepartmentFilter");
        },
        handleFilterClick(category) {
            this.$store.commit("filterDepartmentClick", category);
        },
        isChecked(category) {
            return this.selectedDepartmentFilters.some(filter => filter.slug === category.slug);
        },
        handleEscape(event) {
            if (event.key === "Escape" && this.filterOpen) {
                this.closeFilter();
            }
        },
    }
};
</script>
